module.exports = __webpack_public_path__ + "assets/img/banner1.f2189855.png";